<template>
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 10.866 3.63401 14 7.5 14C11.366 14 14.5 10.866 14.5 7C14.5 3.13401 11.366 0 7.5 0ZM7.5 3.9375C5.80863 3.9375 4.4375 5.30863 4.4375 7C4.4375 8.69137 5.80863 10.0625 7.5 10.0625C9.19137 10.0625 10.5625 8.69137 10.5625 7C10.5625 5.30863 9.19137 3.9375 7.5 3.9375Z"
        />
    </svg>
</template>